module.exports = __webpack_public_path__ + "img/gestisci_prenoatzione.97fa9378.svg";